import { sortingToOptionValue } from './sorting_to_option_value';
import { sortingToOptionLabel } from './sorting_to_option_label';

function sortingOptionsToSelectOptions(sortingOptions) {
    return sortingOptions.map((sorting) => [
        sortingToOptionValue(sorting),
        sortingToOptionLabel(sorting)
    ]);
}

export { sortingOptionsToSelectOptions };